$(function () {
	const carousel = ".owl-carousel.products-carousel"

	const carouselOptions = {
		loop: $(carousel).data("nav"),
		dots: $(carousel).data("dots"),
		nav: $(carousel).data("nav"),
      	autoplay: $(carousel).data("autoplay"),
      	autoplayHoverPause: true,
      	rewind: true,
		margin: 20,
		responsive: {
			0: {
				items: 1,
			},
			425: {
				items: 2,
			},
			575: {
				items: 3,
			},
			639: {
				items: 4,
			},
			1023: {
				items: 5,
			},
		},
		onInitialized: function (event) {
			const target = event.target.id ? event.target.id : event.target.classList[1]
			console.log(`${target} has been initialized.`)
		},
	}

	if ($(carousel).length > 0) {
		$(carousel).owlCarousel(carouselOptions)
	}

	Shopify.designMode &&
		document.addEventListener("shopify:section:load", (event) => {
			if ($(event.target).hasClass("page-back-to-school-template")) {
				console.log("Products List Carousel has been reload!")

				$(carousel).trigger("destroy.owl.carousel")
				$(carousel).owlCarousel(carouselOptions)
			}
		})
})
